import { EditIcon, LockIcon, UnlockIcon } from '@chakra-ui/icons'
import { Box, Button, Center, Flex, HStack, Text, Tooltip, VStack } from '@chakra-ui/react'
import { useFirebase } from '@chem-po/firebase-web'
import { getTemplateCollectionPath, PracticeContractTemplate, WithId } from '@hb/shared'
import { doc } from 'firebase/firestore'
import { useCallback, useState } from 'react'
import { useUpdateDoc } from '../../../hooks/backend/useUpdateDoc'
import { SolidActionButton } from '../../Buttons/ActionButton'

const IsInternalView = ({ template }: { template: WithId<PracticeContractTemplate> }) => {
  const update = useUpdateDoc('template permissions')
  const { firestore } = useFirebase()
  const [isLoading, setIsLoading] = useState(false)
  const handleChange = useCallback(
    async (value: boolean) => {
      setIsLoading(true)
      const ref = doc(
        firestore,
        `${getTemplateCollectionPath(null, 'practiceContract')}/${template.id}`,
      )
      await update(ref, 'isInternal', value)
      setIsLoading(false)
    },
    [template, firestore, update],
  )
  return (
    <Flex w="100%" pt={2} px={2}>
      <Tooltip label="Internal templates cannot be sent to a provider" placement="top" hasArrow>
        <Button
          variant="ghost"
          size="sm"
          isLoading={isLoading}
          gap={2}
          onClick={() => handleChange(!template.isInternal)}>
          {template.isInternal ? <LockIcon color="#f5c802" /> : <UnlockIcon color="gray.400" />}
          <Text fontWeight={400} fontSize="sm" fontFamily="Hero-New">
            {template.isInternal ? 'Internal use (Cannot be sent)' : 'Can be sent to providers'}
          </Text>
        </Button>
      </Tooltip>
    </Flex>
  )
}

export const PracticeContractPreview = ({
  template,
  onOpenTemplate,
  openText = 'Edit Template',
}: {
  template: WithId<PracticeContractTemplate>
  onOpenTemplate?: () => void
  openText?: string
}) => (
  <VStack py={1} w="100%" mb={1} fontFamily="Hero-New" align="flex-start" borderColor="gray.200">
    <HStack spacing={0} w="100%">
      <Box flex={1} minW="0" borderRight="1px solid" borderColor="gray.200">
        <IsInternalView template={template} />
      </Box>
      <Center px={3} flexFlow="column">
        <Text fontSize="md" fontFamily="Open Sans" color="gray.600">
          Template
        </Text>
        <SolidActionButton gap={2} size="sm" onClick={onOpenTemplate}>
          <EditIcon filter="drop-shadow(1px 1px 3px #00000077)" />
          <Text>{openText}</Text>
        </SolidActionButton>
      </Center>
    </HStack>
  </VStack>
)
